"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InCallDetailsContentTray = exports.DetailsTabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const rxjs_1 = require("../../../hooks/rxjs");
const room_session_1 = require("../../../context/room_session");
const in_call_streemshots_1 = require("./in_call_streemshots");
const in_call_bookmarks_1 = require("./in_call_bookmarks");
const in_call_notes_1 = require("./in_call_notes");
const legacy_in_call_customer_details_1 = require("./legacy_in_call_customer_details");
const use_bookmark_to_select_1 = require("../../../hooks/use_bookmark_to_select");
const use_media_breakpoint_1 = require("../../../hooks/use_media_breakpoint");
const network_quality_1 = require("./network_quality/network_quality");
const company_settings_1 = require("../../../context/company_settings");
const share_link_button_1 = require("../video_frame/share_link/share_link_button");
const company_info_1 = require("../../../context/company_info");
const in_call_call_details_1 = require("./call_details/in_call_call_details");
const brand_logo_1 = require("../../brand_logo");
var DetailsTabs;
(function (DetailsTabs) {
    DetailsTabs[DetailsTabs["Notes"] = 0] = "Notes";
    DetailsTabs[DetailsTabs["Streemshots"] = 1] = "Streemshots";
    DetailsTabs[DetailsTabs["Bookmarks"] = 2] = "Bookmarks";
    DetailsTabs[DetailsTabs["Measurements"] = 3] = "Measurements";
    DetailsTabs[DetailsTabs["Details"] = 4] = "Details";
})(DetailsTabs = exports.DetailsTabs || (exports.DetailsTabs = {}));
const InCallDetailsContentTray = ({ isTrayOpen }) => {
    var _a, _b, _c;
    const [activeTab, setActiveTab] = (0, react_1.useState)(DetailsTabs.Notes);
    const roomSession = (0, room_session_1.useRoomSession)();
    const companySettings = (0, company_settings_1.useCompanySettings)();
    const { isSmallScreen } = (0, use_media_breakpoint_1.useMediaBreakpoint)();
    const [bookmarkToSelect] = (0, use_bookmark_to_select_1.useBookmarkToSelect)();
    const [remoteUser] = (0, rxjs_1.useObservable)(roomSession.user.remoteUser);
    const [room] = (0, rxjs_1.useObservable)(roomSession === null || roomSession === void 0 ? void 0 : roomSession.room.room);
    const companyInfo = (0, company_info_1.useCompanyInfo)();
    const brandSettings = roomSession.callSettings.brandSettings;
    (0, react_1.useEffect)(() => {
        if (bookmarkToSelect) {
            setActiveTab(DetailsTabs.Bookmarks);
        }
    }, [bookmarkToSelect]);
    const tabs = [
        {
            key: DetailsTabs.Notes,
            title: 'Notes',
            content: (0, jsx_runtime_1.jsx)(in_call_notes_1.InCallNotes, {}, "in-call-notes"),
        },
    ];
    if (roomSession.callSettings.showReservationCallDetailYn && (room === null || room === void 0 ? void 0 : room.callDetail)) {
        tabs.push({
            key: DetailsTabs.Details,
            title: 'Details',
            content: ((0, jsx_runtime_1.jsx)(in_call_call_details_1.InCallCallDetails, { room: room, isTrayOpen: isTrayOpen }, "in-call-call-detail")),
        });
    }
    else if ((_a = room === null || room === void 0 ? void 0 : room.details) === null || _a === void 0 ? void 0 : _a.length) {
        tabs.push({
            key: DetailsTabs.Details,
            title: 'Details',
            content: (0, jsx_runtime_1.jsx)(legacy_in_call_customer_details_1.LegacyInCallCustomerDetails, {}, "in-call-customer-details"),
        });
    }
    tabs.push({
        key: DetailsTabs.Streemshots,
        title: 'Streemshots',
        content: (0, jsx_runtime_1.jsx)(in_call_streemshots_1.InCallStreemshots, {}, "in-call-streemshots"),
    });
    tabs.push({
        key: DetailsTabs.Bookmarks,
        title: 'Bookmarks',
        content: (0, jsx_runtime_1.jsx)(in_call_bookmarks_1.InCallBookmarks, {}, "in-call-bookmarks"),
    });
    return ((0, jsx_runtime_1.jsxs)(InCallDetailsContentContainer, { children: [(0, jsx_runtime_1.jsxs)(HeaderWrapper, { children: [roomSession.callSettings.showReservationCallDetailYn && brandSettings && ((0, jsx_runtime_1.jsx)(BrandHeader, { "data-testid": "in-call-brand-header", brandLogoUrl: (_b = brandSettings.brandLogoUrl) !== null && _b !== void 0 ? _b : null, brandName: (_c = brandSettings.brandName) !== null && _c !== void 0 ? _c : ((companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) || 'Streem') })), (0, jsx_runtime_1.jsx)(CustomerHeader, { customerName: remoteUser === null || remoteUser === void 0 ? void 0 : remoteUser.name, roomSessionSid: roomSession.roomId.toString(), companyName: companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName, anonymousShareEnabled: !!(companySettings === null || companySettings === void 0 ? void 0 : companySettings.anonymousShareEnabled) }), (0, jsx_runtime_1.jsx)(network_quality_1.NetworkQuality, {}), (0, jsx_runtime_1.jsx)(ui_react_1.TabsHeader, { tabs: tabs, activeTab: activeTab, setActiveTab: setActiveTab, isSmallScreen: isSmallScreen, dataTestId: "in-call-details-tabs-header" })] }), (0, jsx_runtime_1.jsx)(ui_react_1.TabbedContentContainer, { tabs: tabs, activeTabKey: activeTab, setActiveTabKey: setActiveTab, dataTestId: "in-call-details-tab-content" })] }));
};
exports.InCallDetailsContentTray = InCallDetailsContentTray;
const BrandHeader = ({ brandLogoUrl, brandName, }) => {
    return ((0, jsx_runtime_1.jsxs)(ui_react_1.Row, Object.assign({ alignItems: "center", style: { marginBottom: '1rem' } }, { children: [brandLogoUrl && (0, jsx_runtime_1.jsx)(brand_logo_1.BrandLogo, { logoUrl: brandLogoUrl, "data-testid": "in-call-brand-logo" }), (0, jsx_runtime_1.jsx)(ui_react_1.Header, Object.assign({ size: "xxlarge", style: { padding: '0.1875rem 0' }, "data-testid": "in-call-brand-name" }, { children: brandName }))] })));
};
const CustomerHeader = ({ customerName = 'Customer', roomSessionSid, companyName, anonymousShareEnabled }) => {
    return ((0, jsx_runtime_1.jsxs)(CustomerNameHeader, Object.assign({ "data-testid": "in-call-customer-name-header" }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ headingFontFamily: true, as: "h4", size: "mediumLarge", style: { overflowWrap: 'anywhere' } }, { children: customerName })), (0, jsx_runtime_1.jsx)(share_link_button_1.ShareLinkButton, { roomSid: roomSessionSid, companyName: companyName, anonymousShareEnabled: anonymousShareEnabled })] })));
};
const HeaderWrapper = (0, ui_react_1.styled)(ui_react_1.Box)(({ theme }) => ({
    position: 'sticky',
    top: '0',
    backgroundColor: theme.colors.white,
    width: '100%',
    zIndex: 1,
    paddingTop: '16px',
}));
const InCallDetailsContentContainer = (0, ui_react_1.styled)(ui_react_1.Box)(({ theme }) => ({
    padding: '0 24px',
    backgroundColor: theme.colors.white,
}));
const CustomerNameHeader = (0, ui_react_1.styled)(ui_react_1.Box)({
    display: 'flex',
    justifyContent: 'space-between',
});
//# sourceMappingURL=in_call_details_content_tray.js.map